/* eslint-disable max-statements */

export const DOCUMENT_LOAD_MODEL_REQUESTED = "DOCUMENT_WORKFLOW_EDITOR/LOAD_MODEL_REQUESTED";
export const DOCUMENT_LOAD_MODEL_SUCCESS = "DOCUMENT_WORKFLOW_EDITOR/LOAD_MODEL_SUCCESS";
export const DOCUMENT_LOAD_MODEL_FAIL = "DOCUMENT_WORKFLOW_EDITOR/LOAD_MODEL_FAIL";

export const DOCUMENT_SAVE_MODEL_REQUESTED = "DOCUMENT_WORKFLOW_EDITOR/SAVE_MODEL_REQUESTED";
export const DOCUMENT_SAVE_MODEL_SUCCESS = "DOCUMENT_WORKFLOW_EDITOR/SAVE_MODEL_SUCCESS";
export const DOCUMENT_SAVE_MODEL_FAIL = "DOCUMENT_WORKFLOW_EDITOR/SAVE_MODEL_FAIL";

export const DOCUMENT_ACTIVATE_MODEL_REQUESTED = "DOCUMENT_WORKFLOW_EDITOR/ACTIVATE_MODEL_REQUESTED";
export const DOCUMENT_ACTIVATE_MODEL_SUCCESS = "DOCUMENT_WORKFLOW_EDITOR/ACTIVATE_MODEL_SUCCESS";
export const DOCUMENT_ACTIVATE_MODEL_FAIL = "DOCUMENT_WORKFLOW_EDITOR/ACTIVATE_MODEL_FAIL";

export default (
    state = {
        errors: [],
        hasInitialData: false,
        loading: 0,
        model: {},
        updating: 0,
    },
    { type, data }
) => {
    switch (type) {
        case DOCUMENT_LOAD_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case DOCUMENT_LOAD_MODEL_SUCCESS: {
            --state.loading;
            state.hasInitialData = true;
            state.model = data;
            return state;
        }
        case DOCUMENT_LOAD_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case DOCUMENT_SAVE_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case DOCUMENT_SAVE_MODEL_SUCCESS: {
            --state.loading;
            state.model = data;
            return state;
        }
        case DOCUMENT_SAVE_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case DOCUMENT_ACTIVATE_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case DOCUMENT_ACTIVATE_MODEL_SUCCESS: {
            --state.loading;
            state.model = data;
            return state;
        }
        case DOCUMENT_ACTIVATE_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        default:
            return state;
    }
};

export const requestDocumentLoadWorkflowModel = data => ({ type: DOCUMENT_LOAD_MODEL_REQUESTED, data });
export const successDocumentLoadWorkflowModel = data => ({ type: DOCUMENT_LOAD_MODEL_SUCCESS, data });
export const failDocumentLoadWorkflowModel = data => ({ type: DOCUMENT_LOAD_MODEL_FAIL, data });

export const requestDocumentSaveWorkflowModel = (data, resolve, reject) => ({ type: DOCUMENT_SAVE_MODEL_REQUESTED, data, resolve, reject });
export const successDocumentSaveWorkflowModel = data => ({ type: DOCUMENT_SAVE_MODEL_SUCCESS, data });
export const failDocumentSaveWorkflowModel = data => ({ type: DOCUMENT_SAVE_MODEL_FAIL, data });

export const requestDocumentActivateWorkflow = (data, resolve, reject) => ({ type: DOCUMENT_ACTIVATE_MODEL_REQUESTED, data, resolve, reject });
export const successDocumentActivateWorkflow = data => ({ type: DOCUMENT_ACTIVATE_MODEL_SUCCESS, data });
export const failDocumentActivateWorkflow = data => ({ type: DOCUMENT_ACTIVATE_MODEL_FAIL, data });
